import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    sectionContent: {
      margin: '0 0 32px',
      marginTop: 30,
      flex: 1,
      width: '100%',
    },
    sectionContentList: {
      margin: '0 0 32px',
      flex: 1,
    },
    environmentDashboard: {
      marginTop: 15,
    },
    maintenanceIcon: {
      fontSize: 35,
      marginLeft: 15,
      animation: '$maintenanceIcon 1s linear infinite',
    },
    '@keyframes maintenanceIcon': {
      '50%': {
        opacity: 0,
      },
    },
    maintenanceWarn: { display: 'flex', alignItems: 'center' },
    maintenanceText: {
      fontWeight: 500,
      marginLeft: 6,
      color: palette.darkRed,
      fontSize: 14,
    },
    red: {
      border: `1px solid ${palette.error.light}`,
      background: palette.error.main,
      color: palette.error.contrastText,
      padding: '8px 16px',
      fontSize: '12px',
      height: 30,

      '&:hover': {
        backgroundColor: palette.error.dark,
      },
    },
    environmentHead: { width: '60%' },

    status: {
      border: `1px solid ${palette.blue}`,
      borderRadius: 16,
      color: palette.blue,
      padding: 8,
      height: 30,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '4px',
      cursor: 'default',
      maxWidth: '10%',
      transition: 'max-width 0.1s ease-out',

      [breakpoints.down('xl')]: {
        maxWidth: '20%',
      },

      '& .MuiTypography-root': {
        color: palette.blue,
        fontSize: 12,
        fontWeight: 500,
      },
      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: palette.blue,
      },

      '& .statusDescription': {
        whiteSpace: 'nowrap',
        display: 'inline-block',
        width: 0,
        overflow: 'hidden',
      },

      '&:hover, &:active': {
        '& .statusDescription': {
          width: 'fit-content',
        },
        transition: 'max-width 0.2s ease-in',
        maxWidth: '40%',
      },
    },
  });
